import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { PowerBiConfig } from 'src/app/reporting/reports/models/power-bi.config';
import { ReportInfo } from 'src/app/reporting/reports/models/report.info';
import { PowerBiSettings } from 'src/app/reporting/reports/models/power-bi.settings';
import { Observable } from 'rxjs';
import { PowerBiExportStatus } from 'src/app/reporting/reports/models/powerbi-export-status.model';
import { PowerBiExportRequest } from 'src/app/reporting/reports/models/powerbi-export-request.model';

@Injectable({
    providedIn: 'root'
})
export class ReportsService {
    private coreApiPath: string;

    constructor(
        @Inject(APP_CONFIG) settings: Settings,
        private readonly http: HttpClient
    ) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
    }

    getReports(): Observable<ReportInfo[]> {
        const url = `${this.coreApiPath}/report`;
        return this.http.get<ReportInfo[]>(url);
    }

    getPowerBIAccessData(reportId: number, isRefresh = false): Observable<PowerBiConfig> {
        const url = `${this.coreApiPath}/report/power-bi/${reportId}?isRefresh=${isRefresh}`;
        return this.http.get<PowerBiConfig>(url);
    }

    saveSettings(reportId: number, settings: PowerBiSettings, page: string): Observable<boolean> {
        const url = `${this.coreApiPath}/report/power-bi/${reportId}/settings/${page}`;
        return this.http.post<boolean>(url, { settings: JSON.stringify(settings) });
    }

    clearSettings(reportId: number): Observable<boolean> {
        const url = `${this.coreApiPath}/report/power-bi/${reportId}/settings`;
        return this.http.delete<boolean>(url);
    }

    getSettings(reportId: number, page: string): Observable<PowerBiSettings> {
        const url = `${this.coreApiPath}/report/power-bi/${reportId}/settings/${page}`;
        return this.http.get<PowerBiSettings>(url);
    }

    exportToFile(reportId: number, requestModel: PowerBiExportRequest): Observable<PowerBiExportStatus> {
        const url = `${this.coreApiPath}/report/power-bi/${reportId}/export-to-file`;
        return this.http.post<PowerBiExportStatus>(url, requestModel);
    }

    getExportStatus(reportId: number, exportId: string): Observable<PowerBiExportStatus> {
        const url = `${this.coreApiPath}/report/power-bi/${reportId}/export-to-file/status/${exportId}`;
        return this.http.get<PowerBiExportStatus>(url);
    }

    downloadExportFile(reportId: number, exportId: string): Observable<HttpResponse<ArrayBuffer>> {
        const url = `${this.coreApiPath}/report/power-bi/${reportId}/export-to-file/download/${exportId}`;
        return this.http.get(url, { observe: 'response', responseType: 'arraybuffer' });
    }
}
